import type { Trace, Span } from "@/models/traces";

// Type definition for the Trace module Vuex state object.
export interface TraceState {
  filename: string | undefined;
  trace: Trace | undefined;
  spans: Array<Span> | undefined;
}

/**
 * Create a state object for the Trace module.
 * @returns A state object initialized for use in the Trace module.
 */
export function makeState(): TraceState {
  return {
    filename: undefined,
    trace: undefined,
    spans: undefined,
  };
}
